import { __extends } from "tslib";
import { GetCampaignVersionRequest, GetCampaignVersionResponse } from "../models/index";
import { deserializeAws_restJson1GetCampaignVersionCommand, serializeAws_restJson1GetCampaignVersionCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetCampaignVersionCommand = /** @class */ (function (_super) {
    __extends(GetCampaignVersionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCampaignVersionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetCampaignVersionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetCampaignVersionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetCampaignVersionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCampaignVersionCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetCampaignVersionCommand(input, context);
    };
    GetCampaignVersionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetCampaignVersionCommand(output, context);
    };
    return GetCampaignVersionCommand;
}($Command));
export { GetCampaignVersionCommand };
//# sourceMappingURL=GetCampaignVersionCommand.js.map